import { AclLiterals } from '@trukt/types/Report';

export const isReportPrivate = (visibility: AclLiterals) => {
  return visibility === 'owner';
};
